var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 55,
    viewBox: "0 0 68 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Logo"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M36.101 52.4279C24.6383 57.1255 12.4588 55.0453 5.56649 47.3259C2.23942 43.5996 0.208439 39.1825 0.114872 34.2147C-0.0909714 23.2858 0.0409716 12.3505 0.0490884 1.41774C0.0493828 1.02205 0.197919 0.626471 0.307528 0.0806465C4.10409 0.0806465 7.81778 0.0806465 12.0852 0.0806465C12.0852 1.12007 12.0851 2.21553 12.0853 3.31099C12.0864 12.3516 12.1006 21.3923 12.0835 30.4328C12.0747 35.1244 13.7538 39.0474 17.2466 42.1346C20.826 45.2983 25.5504 45.7555 29.7467 43.5132C34.743 40.8433 36.8467 36.4941 36.9179 30.9984C36.9855 25.7687 36.9324 20.5375 36.9324 15.3504C43.357 14.6965 48.2301 18.0586 48.9025 24.024C49.9766 33.5551 49.758 42.8984 41.149 49.4759C39.6711 50.6051 37.9378 51.3931 36.101 52.4279Z",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M47.9943 52.5745C55.0536 44.1509 56.2711 34.3055 55.0275 23.8137C54.2165 16.9715 50.1476 12.0743 43.4307 10.9557C39.3873 10.2823 35.2119 10.4083 30.6585 10.1503C30.6585 13.6199 30.6641 16.6102 30.6571 19.6004C30.647 23.8731 30.7604 28.1518 30.5697 32.4165C30.4208 35.748 27.4675 38.6806 24.6904 38.6742C21.6261 38.6671 18.7766 36.0829 18.7281 32.5985C18.5805 21.9915 18.6746 11.381 18.6746 0.0806465C28.3038 0.462139 37.8069 -0.0102618 47.016 1.42367C57.9222 3.12184 65.0235 10.3699 67.2326 21.3365C69.4717 32.4522 67.0187 42.3881 57.1032 49.1379C54.5148 50.8999 51.2626 51.6776 48.1375 52.7258C47.9596 52.5443 47.9943 52.5745 47.9943 52.5745Z",
    fill: "#080808"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.2ce16c91cd73b35ba9c99d965921de52.svg";
export { ForwardRef as ReactComponent };